<script setup lang="ts">
import {Building2, ClipboardCheck, Construction, LandPlot, MoveLeft, MoveRight} from 'lucide-vue-next';
import {RouterLink} from 'vue-router';
import SectionHeading from './SectionHeading.vue';
import {useLanguage} from '../composables/useLanguage';

const {isArabic} = useLanguage();
const services = [
  {
    icon: Construction,
    titleAr: 'المقاولات العامة', titleEn: 'General Contracting',
    textAr: 'تنفيذ متكامل للمشاريع السكنية والتجارية والصناعية وفق المواصفات والبرامج الزمنية المعتمدة.',
    textEn: 'Integrated delivery of residential, commercial and industrial projects to approved standards and schedules.',
  },
  {
    icon: LandPlot,
    titleAr: 'البنية التحتية', titleEn: 'Infrastructure',
    textAr: 'تنفيذ الطرق وشبكات الخدمات والمرافق والأعمال المدنية بكفاءة هندسية عالية.',
    textEn: 'Roads, utilities, networks and civil works delivered with high engineering efficiency.',
  },
  {
    icon: Building2,
    titleAr: 'الاستثمار العقاري', titleEn: 'Real Estate Investment',
    textAr: 'تطوير وإدارة فرص عقارية مدروسة تحقق قيمة مستدامة وعوائد طويلة الأجل.',
    textEn: 'Development and management of sound property opportunities that create sustainable long-term value.',
  },
  {
    icon: ClipboardCheck,
    titleAr: 'إدارة المشاريع', titleEn: 'Project Management',
    textAr: 'إدارة احترافية من التخطيط والتكلفة حتى التسليم، مع رقابة مستمرة على الجودة والسلامة.',
    textEn: 'Professional management from planning and cost control through handover, quality and safety.',
  },
];
</script>

<template>
  <section id="services" class="section services-section">
    <div class="container">
      <SectionHeading
        :eyebrow="isArabic ? 'خدماتنا' : 'Our services'"
        :title="isArabic ? 'حلول متكاملة في البناء والاستثمار' : 'Integrated construction and investment solutions'"
        :description="isArabic ? 'خبرة عملية ومنهجية واضحة لتطوير وتنفيذ المشاريع بكفاءة.' : 'Practical expertise and a clear method for efficient project development and delivery.'"
      />
      <div class="services-grid">
        <article v-for="service in services" :key="service.titleEn" class="service-card reveal">
          <span class="icon-box"><component :is="service.icon" :size="32" /></span>
          <h3>{{ isArabic ? service.titleAr : service.titleEn }}</h3>
          <p>{{ isArabic ? service.textAr : service.textEn }}</p>
          <RouterLink to="/contact" class="text-link">
            {{ isArabic ? 'اعرف المزيد' : 'Learn more' }}
            <MoveLeft v-if="isArabic" :size="17" /><MoveRight v-else :size="17" />
          </RouterLink>
        </article>
      </div>
    </div>
  </section>
</template>
